import React from 'react';
import { adminAPI } from '../../InterfaceAPI/adminAPI';
import ActionItems from '../dashboard/ActionItems';
import withSplashMessage from '../splashMessage/withSplashMessage';
import { stringfyServerErrors } from '../../helpers/util';
import ServiceCounts from '../dashboard/ServiceCounts';
import ClientCounts from '../dashboard/ClientCounts';
import ChefCounts from '../dashboard/ChefCounts';
import WeeklyMenus from '../dashboard/WeeklyMenus';
import withTracker from '../withTracker';
import Loader from '../shared/Loader';

class AdminDashboard extends React.Component {
  state = {
    action_items: {},
    chefs: {},
    clients: {},
    menus: [],
    services: {},
    isLoading: false
  };

  render() {
    return (
      <div className="cms">
        <div className="cms__body">
          <div className="cms__content">
            <div className="row">
              <div className="row__item row__item--two-third row__item--pad-right">
                <ActionItems actionItems={this.state.action_items} />
              </div>

              <div className="row__item row__item--third row__item--pad-left">
                <ServiceCounts counts={this.state.services} />
              </div>
            </div>

            <div className="row">
              <div className="row__item">
                <WeeklyMenus menus={this.state.menus} />
              </div>
            </div>

            <div className="row">
              <div className="row__item row__item--half row__item--pad-right">
                <ClientCounts counts={this.state.clients} />
              </div>

              <div className="row__item row__item--half row__item--pad-left">
                <ChefCounts counts={this.state.chefs} />
              </div>
            </div>
          </div>
        </div>
        {this.state.isLoading && <Loader />}
      </div>
    );
  }

  componentDidMount() {
    this.setState({ isLoading: true });

    adminAPI
      .getDashboard()
      .then(dashboard => {
        this.setState({
          isLoading: false
        });
        this.setState(dashboard);
      })
      .catch(err =>
        this.props.addMessage({
          className: 'error',
          message: stringfyServerErrors(err)
        })
      );
  }
}

export default withSplashMessage(withTracker(AdminDashboard));



// WEBPACK FOOTER //
// ./src/components/admin/AdminDashboard.js